import AuthBgWrapper from '@/features/auth/components/auth-bg-wrapper'
import AuthCardWrapper from '@/features/auth/components/auth-card-wrapper'
import ForgotPasswordForm from '@/features/auth/components/forms/forgot-password-form'
import { forgotPasswordScreenBgImage } from '@/features/auth/constants/image'
import React from 'react'

function ForgotPasswordPage() {
    return (
        <AuthBgWrapper image={forgotPasswordScreenBgImage}>
            <AuthCardWrapper
                headerTitle='Forgot Your Password?'
                headerDescription={`Please enter your email address, and we' ll send you a link to reset your password.`}
            >
                <ForgotPasswordForm />
            </AuthCardWrapper>
        </AuthBgWrapper>
    )
}

export default ForgotPasswordPage